export default function Privacy() {
    return (
        <div className="max-w-5xl mx-auto mt-8 px-4 space-y-8">
            <h1 className="text-4xl font-bold text-center">Privacy Policy</h1>
            <p className="text-center">Effective Date: October 31, 2025</p>

            <ol className="list-decimal text-lg list-inside space-y-6">
                <li>
                    <h2 className="inline text-lg font-semibold">Introduction</h2>
                    <p className="mt-1 text-md">
                        Welcome to GiftLoop (“we,” “our,” or “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect the personal information you provide when using our gift registry app (“App”). By using the App, you consent to the practices described in this Privacy Policy.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Information We Collect</h2>
                    <p className="mt-1 text-md">We collect the following types of personal information:</p>
                    <ul className="list-disc list-inside text-md ml-4 mt-2 space-y-1">
                        <li><span className="font-semibold">Account Information:</span> Name, email address, and mailing address.</li>
                        <li><span className="font-semibold">User Content:</span> Gift lists, item URLs, and notes you add to your registry.</li>
                        <li><span className="font-semibold">Usage Data:</span> Information collected automatically through Google Analytics, such as device type, browser type, pages visited, and interactions within the App.</li>
                    </ul>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">How We Use Your Information</h2>
                    <p className="mt-1 text-md">We use your information to:</p>
                    <ul className="list-disc list-inside text-md ml-4 mt-2 space-y-1">
                        <li>Create and manage your gift registries.</li>
                        <li>Enable shared registries and collaboration.</li>
                        <li>Send you updates, notifications, or support messages related to your registries.</li>
                        <li>Analyze usage patterns via Google Analytics to improve our App.</li>
                    </ul>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Sharing Your Information</h2>
                    <p className="mt-1 text-md">We do not sell your personal information. We may share information with:</p>
                    <ul className="list-disc list-inside text-md ml-4 mt-2 space-y-1">
                        <li>Service Providers: Such as Google Analytics and Firebase, for app functionality and analytics.</li>
                        <li>Legal Requirements: If required by law, regulation, or legal process.</li>
                    </ul>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Children’s Privacy</h2>
                    <p className="mt-1 text-md">
                        Our App may be used by individuals under 18 with parental consent. We do not knowingly collect personal information from children without parental consent.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Data Security</h2>
                    <p className="mt-1 text-md">
                        We implement reasonable measures to protect your information from unauthorized access, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">International Users</h2>
                    <p className="mt-1 text-md">
                        If you access the App from outside the United States, please note that your information may be transferred to and stored in the U.S., where privacy laws may differ.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Your Rights</h2>
                    <p className="mt-1 text-md">
                        You may request access to, correction of, or deletion of your personal information by contacting us at <a href="mailto:giftloopapp@gmail.com" className="text-blue-600 underline">giftloopapp@gmail.com</a>.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Updates to the Privacy Policy</h2>
                    <p className="mt-1 text-md">
                        We may update this Privacy Policy from time to time. We encourage you to review it periodically for any changes.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Contact Us</h2>
                    <p className="mt-1 text-md">
                        For questions or concerns regarding this Privacy Policy, contact us at <a href="mailto:giftloopapp@gmail.com" className="text-blue-600 underline">giftloopapp@gmail.com</a>.
                    </p>
                </li>
            </ol>
        </div>
    );
}
